<script>
    import { onMount } from "svelte";
    import { cuenta, documentos, recetaActiva } from "./store.js";

    async function updateDocumentos() {
        const allDocs = await db.allDocs({
            include_docs: true,
        });
        $documentos = allDocs.rows.map((row) => row.doc);
    }
    function setActivo(documento,nombre,mutual,afiliado,cuerpo){
        $recetaActiva = {documento:documento,nombre:nombre,mutual:mutual,afiliado:afiliado,cuerpo:cuerpo};
    }
    export async function crearReceta(documento,nombre,mutual,afiliado,cuerpo){
        let fecha = new Date();
        let doc = {
            _id: `recetas:${$cuenta.user}.${nombre}.${fecha.getDate()}-${fecha.getMonth() + 1}-${fecha.getFullYear()}.${fecha.getHours()}:${fecha.getMinutes()}Hs`,
            documento: documento,
            nombre: nombre,
            mutual:mutual,
            afiliado: afiliado,
            cuerpo: cuerpo,
            creado: fecha.toISOString(),
            anulado: false,
            doctor: $cuenta.user,
            firma: $cuenta.firma,
            titulo: $cuenta.titulo,
            matricula: $cuenta.matricula
        }
        const addition = await db.post(doc);
        if (addition.ok) {
            setActivo('','','','','');
            await updateDocumentos();
        }
    }
    export async function anularReceta(id,rev){
        let newDoc ={
            _id: id,
            _rev: rev,
            anulado: true
        }
        const update = await db.put(newDoc);
        if (update.ok) {
            await updateDocumentos();
            return {
                status: 200,
                valor:"/historial"
            };
        } else {
            return {
                status: 400,
                valor:"/historial"
            }
        }
    }
    export async function obtenerRecetas(){
        let lista = $documentos.filter((el)=>{el._id.includes(`recetas:${cuenta.user}`)});
        return lista;
    }
    export async function crearPlantilla(nombre,cuerpo){
        let fecha = new Date();
        let doc = {
            _id: `plantillas:${$cuenta.user}.${nombre}.${fecha.getDate()}-${fecha.getMonth() + 1}-${fecha.getFullYear()}.${fecha.getHours()}:${fecha.getMinutes()}Hs`,
            cuerpo: cuerpo,
            nombre: nombre,
            creado: fecha.toISOString()
        }
        const addition = await db.post(doc);
        if (addition.ok) {
            await updateDocumentos();
        }
    }
    export async function editarPlantilla(id,cuerpo,rev){
        let newDoc ={
            _id: id,
            _rev: rev,
            cuerpo: cuerpo
        }
        const update = await db.put(newDoc);
        if (update.ok) {
            await updateDocumentos();
            return {
                status: 200,
                valor:"/home"
            };
        } else {
            return {
                status: 400,
                valor:"/home"
            }
        }
    }
    export async function eliminarPlantilla(id){
        const { todo: todoToRemove } = {_id:id};
        const removal = await db.remove(todoToRemove);
        if (removal.ok) {
            // For removal, we can just update the local state instead of reloading everything from PouchDB,
            // since we no longer care about the doc’s revision.
            $documentos = $documentos.filter((todo) => {
                return todo._id !== todoToRemove._id;
            });
        }
    }
    export async function obtenerPlantillas(){
        let lista = $documentos.filter((el)=>el._id.includes(`plantillas:${$cuenta.user}`));
        return lista;
    }
</script>